import { DEBUG } from '@glimmer/env';
import WeakCache from '../weak-cache';
const AvailableShims = new WeakCache(DEBUG ? 'schema-shims' : '');
AvailableShims._generator = () => {
  return Object.create(null);
};
export function getShimClass(store, modelName) {
  let shims = AvailableShims.lookup(store);
  let shim = shims[modelName];
  if (shim === undefined) {
    shim = shims[modelName] = new ShimModelClass(store, modelName);
  }
  return shim;
}
function mapFromHash(hash) {
  let map = new Map();
  for (let i in hash) {
    if (Object.prototype.hasOwnProperty.call(hash, i)) {
      map.set(i, hash[i]);
    }
  }
  return map;
}

// Mimics the static apis of DSModel
export default class ShimModelClass {
  // TODO Maybe expose the class here?
  constructor(__store, modelName) {
    this.__store = __store;
    this.modelName = modelName;
  }
  get fields() {
    let attrs = this.__store._attributesDefinitionFor({
      type: this.modelName
    });
    let relationships = this.__store._relationshipsDefinitionFor({
      type: this.modelName
    });
    let fields = new Map();
    Object.keys(attrs).forEach(key => fields.set(key, 'attribute'));
    Object.keys(relationships).forEach(key => fields.set(key, relationships[key].kind));
    return fields;
  }
  get attributes() {
    let attrs = this.__store._attributesDefinitionFor({
      type: this.modelName
    });
    return mapFromHash(attrs);
  }
  get relationshipsByName() {
    let relationships = this.__store._relationshipsDefinitionFor({
      type: this.modelName
    });
    return mapFromHash(relationships);
  }
  eachAttribute(callback, binding) {
    let attrDefs = this.__store._attributesDefinitionFor({
      type: this.modelName
    });
    Object.keys(attrDefs).forEach(key => {
      callback.call(binding, key, attrDefs[key]);
    });
  }
  eachRelationship(callback, binding) {
    let relationshipDefs = this.__store._relationshipsDefinitionFor({
      type: this.modelName
    });
    Object.keys(relationshipDefs).forEach(key => {
      callback.call(binding, key, relationshipDefs[key]);
    });
  }
  eachTransformedAttribute(callback, binding) {
    let relationshipDefs = this.__store._relationshipsDefinitionFor({
      type: this.modelName
    });
    Object.keys(relationshipDefs).forEach(key => {
      if (relationshipDefs[key].type) {
        callback.call(binding, key, relationshipDefs[key]);
      }
    });
  }
}